export const errorSources = {
  FULFILLMENT: "FULFILLMENT_AUTH_API",
  EQUIFAX: "EQUIFAX",
  EQUIFAX_AFP: "EQUIFAX_AFP",
  SINACOFI: "SINACOFI"
};

const cuprumEquifaxErrors = [
  {
    codes: ["400", "401", "500", "3023", "3019", "3025", "3016", "3018", "01", "G0"],
    message: "Ups, hubo un error de conexión, inténtalo nuevamente."
  },
  {
    codes: ["3024", "3026", "3031", "C01", "02", "D9", "42"],
    message: "Ups, hubo un error de conexión, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["07", "3027", "3021"],
    message: "Has agotado los 2 intentos para resolver el Desafío de Preguntas, deberás esperar 3 días corridos para volver a intentarlo."
  },
  {
    codes: ["03"],
    message: "El RUT ingresado no cumple con el formato solicitado, inténtalo nuevamente."
  },
  {
    codes: ["G7"],
    message: "Número de serie mal ingresado, inténtalo nuevamente."
  },
  {
    codes: ["S4"],
    message: "Cédula de identidad expirada según registro civil, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["S9"],
    message: "Cédula de identidad no vigente según registro civil, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["SA"],
    message: "Cédula de identidad no emitida por el registro civil, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["SI"],
    message: "Cédula de identidad de persona fallecida según registro civil, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["SM"],
    message: "Cédula de identidad bloqueada según registro civil, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["ST"],
    message: "RUT ingresado no corresponde a RUT de persona natural, inténtalo con tu clave de seguridad."
  }
];

const principalEquifaxErrors = [
  {
    codes: ["01", "42", "G0"],
    message: "Ups, hubo un error de conexión, inténtalo nuevamente."
  },
  {
    codes: ["02"],
    message: "Ups, hubo un error de conexión."
  },
  {
    codes: ["07", "3021"],
    message: "Has agotado los 2 intentos para resolver el Desafío de Preguntas, deberás esperar algunos días."
  },
  {
    codes: ["03"],
    message: "El RUT ingresado no cumple con el formato solicitado, inténtalo nuevamente."
  },
  {
    codes: ["G7"],
    message: "Número de serie mal ingresado, inténtalo nuevamente."
  },
  {
    codes: ["S4"],
    message: "Cédula de identidad expirada según registro civil."
  },
  {
    codes: ["S9"],
    message: "Cédula de identidad no vigente según registro civil."
  },
  {
    codes: ["SA"],
    message: "Cédula de identidad no emitida por el registro civil."
  },
  {
    codes: ["SI"],
    message: "Cédula de identidad de persona fallecida según registro civil."
  },
  {
    codes: ["SM"],
    message: "Cédula de identidad bloqueada según registro civil."
  },
  {
    codes: ["ST"],
    message: "RUT ingresado no corresponde a RUT de persona natural."
  }
];

const sinacofiErrors = [
  {
    codes: ["10000", "10001", "10002", "10003", "10004", "10006", "10013", "10302", "10303", "10306", "10307", "10308", "10309", "10863", "10864", "10865", "10866", "10868", "10869", "10870", "10871", "10872", "10873", "10874"],
    message: "Ups, hubo un error de conexión, inténtalo nuevamente."
  },
  {
    codes: ["10005"],
    message: "El RUT ingresado no es válido, inténtalo nuevamente."
  },
  {
    codes: ["10007"],
    message: "Una o más preguntas fueron contestadas erróneamente, por favor inténtalo otra vez."
  },
  {
    codes: ["10008"],
    message: "Cédula de identidad no vigente según Registro Civil, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["10009"],
    message: "RUT ingresado no corresponde a RUT de persona natural, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["10010", "10014", "10015", "10016", "10019", "10301", "10310"],
    message: "Ups, hubo un error de conexión, inténtalo con tu clave de seguridad."
  },
  {
    codes: ["10011", "10304", "10305", "10867"],
    message: "Has agotado los 2 intentos para resolver el Desafío de Preguntas, deberás esperar 3 días corridos para volver a intentarlo."
  },
  {
    codes: ["10012"],
    message: "Has superado el tiempo límite para responder el desafío preguntas, intente nuevamente."
  },
  {
    codes: ["10018"],
    message: "Ups, no hemos establecido conexión con el Registro Civil, inténtalo nuevamente."
  }
];

const fulfillmentErrors = [
  {
    codes: ["QUIZ_REJECTED_BY_PROVIDER"],
    message: "No hemos podido validar tu identidad, por favor intenta nuevamente."
  }
];

const cuprumErrors = [
  {
    source: errorSources.EQUIFAX_AFP,
    errors: cuprumEquifaxErrors
  },{
    source: errorSources.SINACOFI,
    errors: sinacofiErrors
  },
  {
    source: errorSources.FULFILLMENT,
    errors: fulfillmentErrors
  }
];

const principalErrors = [
  {
    source: errorSources.EQUIFAX,
    errors: principalEquifaxErrors
  },
  {
    source: errorSources.FULFILLMENT,
    errors: fulfillmentErrors
  }
];

export function errorMessageObtainer(company, source, errorCode) {
  var defaultCuprumMessage = { message: "Ups, hubo un error, inténtalo con tu clave de seguridad." };
  var defaultPrincipalMessage = { message: "Ups, hubo un error de conexión, inténtalo nuevamente." };

  if (company === "principal")
    return (principalErrors.find(error => error.source === source).errors.find(error => error.codes.includes(errorCode)) || defaultPrincipalMessage).message;
  else if (company === "cuprum")
    return (cuprumErrors.find(error => error.source === source).errors.find(error => error.codes.includes(errorCode)) || defaultCuprumMessage).message;
  return defaultPrincipalMessage.message;
}
